import React from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import baseTheme from "./theme/baseTheme";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes";

import "./utils/app.css";

function App() {
  return (
    <ThemeProvider theme={baseTheme}>
      <CssBaseline />
      <RouterProvider router={router} />
    </ThemeProvider>
  );
}

export default App;
